import { html } from '@microsoft/fast-element';
import { FoundationElement } from '@microsoft/fast-foundation';
import { ChameleonElementMixin } from '../../common/mixin';
export const dataTableBodyTemplate = html `<template role="rowgroup"><slot></slot></template>`;
export class DataTableBodyComponent extends ChameleonElementMixin(FoundationElement) {
}
